import { Link } from 'react-router-dom';
import { MessageToolPage } from '@/components/seo/MessageToolPage';

export default function ThankYouMessageGenerator() {
  return (
    <MessageToolPage
      title="Thank You Message Generator — Free AI Tool"
      metaDescription="Generate a meaningful thank you message — free. Our AI helps you express gratitude to parents, friends, mentors, and anyone who's made a difference in your life."
      h1="Free Thank You Message Generator"
      subtitle="Gratitude is powerful — but hard to put into words. Let AI help you express it."
      toolLabel="Generate a Thank You Message"
      placeholder="e.g. I want to thank my teacher for believing in me when I didn't believe in myself..."
      systemPrompt="Write a warm, specific thank you message that expresses genuine gratitude. Be personal and meaningful. Reference the impact of the recipient's actions. Tone should be heartfelt, appreciative, and calm."
      faq={[
        { q: 'How do I write a meaningful thank you?', a: 'Be specific. Instead of "thank you for everything," name one thing and explain how it impacted you. Specificity is what transforms polite gratitude into something deeply felt.' },
        { q: 'Can I thank someone I haven\'t spoken to in years?', a: 'Absolutely. Late gratitude is still powerful. Many people carry the impact of someone they lost touch with. Reaching out, even years later, can be profoundly meaningful for both of you.' },
        { q: 'What if I want to thank someone anonymously?', a: 'Say It NOW supports anonymous messages with optional identity reveal. You can express gratitude without revealing yourself until you\'re ready.' },
        { q: 'Is this generator free?', a: 'Yes. Generate thank you messages at no cost. Create a free Say It NOW account for templates, photos, and permanent links.' },
      ]}
      relatedPages={[
        { label: 'Thank You Message for Parents', href: '/thank-you-message-for-parents' },
        { label: 'Heartfelt Message Generator', href: '/tools/heartfelt-message-generator' },
        { label: 'Living Tribute Ideas', href: '/living-tribute-ideas' },
        { label: 'Message to Someone You Love', href: '/message-to-someone-you-love' },
      ]}
      seoContent={
        <>
          <h2>The Science of Gratitude</h2>
          <p>
            Research consistently shows that expressed gratitude benefits both the giver and the receiver. It strengthens relationships, improves mental health, and creates lasting emotional connections. Yet most of us rarely take the time to say thank you in a meaningful way.
          </p>
          <p>
            This free <strong>thank you message generator</strong> makes it easy. Tell us who you're thanking, your relationship, and what you're grateful for — and we'll craft a message that captures your appreciation authentically.
          </p>
          <h2>Who Should You Thank?</h2>
          <ul>
            <li><strong>Parents:</strong> For sacrifices they never mentioned.</li>
            <li><strong>Teachers:</strong> For believing in you when you couldn't.</li>
            <li><strong>Friends:</strong> For showing up when it mattered.</li>
            <li><strong>Partners:</strong> For the daily acts of love you take for granted.</li>
            <li><strong>Colleagues:</strong> For support that went beyond the job description.</li>
          </ul>
          <p>
            For more examples, visit our <Link to="/thank-you-message-for-parents">thank you message for parents</Link> guide or <Link to="/signup">create a beautiful Living Announcement</Link>.
          </p>
        </>
      }
    />
  );
}
